/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React from "react";

interface MessageStripProps {
  messageText: String;
  warning?: boolean;
  error?: boolean;
}

/**
 * Reusable React component - MessageStrip.
 *
 * @namespace MessageStrip
 */
class MessageStrip extends React.Component<MessageStripProps> {
  constructor(props: MessageStripProps) {
    super(props);
    this.state = {
      // submitted: false,
    };
  }

  render() {
    const { messageText, warning, error } = this.props;
    return (
      <div
        className={
          warning
            ? "message-container warning-container"
            : error
            ? "message-container error-container"
            : "message-container "
        }
      >
        <div className={"message"}>{messageText || ""}</div>
      </div>
    );
  }
}

export default MessageStrip;
